import Skeleton from 'react-loading-skeleton'

const DeliveryRangeDateSkeleton = () => (
  <div className='d-flex align-items-center my-3'>
    <Skeleton width={300} height={20} />
  </div>
)

export default DeliveryRangeDateSkeleton
